import { ModalHandler } from '@app-velocity/ui';

import { ProOnlyFeatureModalContent } from './components/ProOnlyFeatureModalContent';

//@TODO - duplicate of apps/main-front
export const ProOnlyFeatureModal = () => {
  return (
    <ModalHandler channel="users" id="pro-feature-only">
      <ProOnlyFeatureModalContent />
    </ModalHandler>
  );
};
